import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tab, Dropdown, Divider, Menu, Button, Popup } from 'semantic-ui-react';
import shortid from 'short-id';
import _ from 'lodash';

import AdPreviewV2 from '../Presentation/AdPreviewV2';
import * as AppActions from '../../actions';
import instagramIcon from '../../assets/images/instagram-icon.png';
import facebookIcon from '../../assets/images/facebook-icon.png';
import InstagramPosts from './components/InstagramPosts';
import FacebookPosts from './components/FacebookPosts';
import './Compliance.css';

class Compliance extends Component {
  state = {
    lobOptions: [],
    selectedLob: null
  };

  componentDidMount() {
    this.props.setSectionTitle('Compliance');
    this.props.saveGTMEvent('Compliance', 'Compliance');
    this.getLobs();
  }

  subStr = (text, limit) => {
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  };

  getLobs = async () => {
    await this.props.actions.fetchLob(this.props.user.sub);
    const lobOptions = _.sortBy(
      _.map(this.props.lobs.lobs, (op, index) => ({
        key: index,
        value: op,
        text: op.name
      })),
      'text'
    );

    this.setState({ lobOptions });
  };

  onLobSelect = async (event, data) => {
    Object.keys(data.value.accounts).map(async (key) => {
      const account = data.value.accounts[key];
      const accessToken =
        account.type === 'instagram'
          ? account.access_token
          : this.props.getFbToken();
      await this.props.actions.fetchPost(
        accessToken,
        account.lob_key,
        key,
        account.type
      );
    });

    this.setState({ selectedLob: data.value });
  };

  renderTabs(lob) {
    const tabs = [];
    // TODO: Below map has to be re-factored
    // eslint-disable-next-line
    Object.keys(lob.accounts).map((key) => {
      const account = lob.accounts[key];

      if (account.type === 'facebookAd') {
        tabs.push({
          menuItem: account.user.username,
          pane: (
            <Tab.Pane key={shortid.generate()}>
              <AdPreviewV2
                getFbToken={this.props.getFbToken}
                accountId={key}
                accountName={account.user.username}
              />
            </Tab.Pane>
          )
        });
      } else {
        const posts = account.data;
        const logo =
          account.type === 'instagram' ? instagramIcon : facebookIcon;
        const accessToken =
          account.type === 'instagram'
            ? account.access_token
            : this.props.getFbToken();
        tabs.push({
          menuItem: (
            <Menu.Item key={key} accessToken={accessToken} type={account.type}>
              <img
                src={logo}
                className="social-logo-test"
                alt={account.user.username}
              />
              {account.user.username}
            </Menu.Item>
          ),
          pane: (
            <Tab.Pane defaultActiveIndex={0}>
              {account.type === 'instagram' ? (
                <InstagramPosts
                  user={this.props.user}
                  posts={posts}
                  subStr={this.subStr}
                />
              ) : (
                <FacebookPosts
                  posts={posts}
                  user={this.props.user}
                  subStr={this.subStr}
                />
              )}
            </Tab.Pane>
          )
        });
      }
    });

    return (
      <Tab
        renderActiveOnly={false}
        key={shortid.generate()}
        defaultActiveIndex={0}
        panes={tabs}
      />
    );
  }

  render() {
    return (
      <div className="container">
        <Dropdown
          placeholder="Select Line of Business"
          search
          selection
          options={this.state.lobOptions}
          onChange={this.onLobSelect}
        />
        <div className="compliance-buttons-container">
          <Popup
            trigger={
              <Button size="small" color="blue">
                Share Link
              </Button>
            }
            content="Sharing disabled for demo users"
            on="hover"
          />
          <Popup
            trigger={
              <Button size="small" color="blue">
                Generate PDF
              </Button>
            }
            content="Generate PDF disabled for demo users"
            on="hover"
          />
        </div>
        <Divider hidden />
        {this.state.selectedLob
          ? this.renderTabs(this.state.selectedLob)
          : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  lobs: state.adShare
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Compliance);



// WEBPACK FOOTER //
// ./src/screens/Compliance/Compliance.js